import { useCallback } from 'react';
import { post } from '../../../../redux/api';
import type { APITokenCreateRequest, APITokenCreateResponse } from '../../../../../shared/settings/apiTokens';
import { useAsyncValue, useRequestConnectedToAsyncValue } from '../../../../hooks';
import { window } from '../../../../globals';

/**
 * Method to hit the endpoint for creating a new API token.
 */
const createNewAPIToken = (userId: number, body: APITokenCreateRequest) =>
  post<APITokenCreateRequest, APITokenCreateResponse>(`/api/user/${userId}/api_token`, body);

/**
 * Async hook which will provide a callback that creates a new API token for the current user.
 * The callback will return the new token response.
 */
const useCreateNewAPIToken = (body: APITokenCreateRequest) => {
  const asyncValue = useAsyncValue<APITokenCreateResponse>(null);
  const request = useCallback(() => {
    return createNewAPIToken(window.user?.id as number, {
      ...body,
      pushOnly: body.pushOnly || 'true',
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps -- The linter is incorrect.
  }, [window.user, body]);
  const onCreateNewAPIToken = useRequestConnectedToAsyncValue(request, asyncValue);

  return {
    asyncValue,
    onCreateNewAPIToken,
  };
};

export default useCreateNewAPIToken;
